import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import CategoryDetailsContent from '../Components/CategoryDetailsContent/CategoryDetailsContent'
import Footer from '../Components/Footer/Footer'
const CategoryDetails = () => {
  return (
    <div className='overflow-x-hidden'>
    <NavBar/>
    <CategoryDetailsContent/>
    <Footer/>
    </div>
  )
}

export default CategoryDetails
